var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import t from 'prop-types';
import * as Util from '../../util';
var NOMBRE_EVENTO_PULSAR = Util.is_touch_device() ? 'onTouchStart' : 'onClick';
var Miniatura = (_temp = _class = function (_React$Component) {
  _inherits(Miniatura, _React$Component);

  function Miniatura(props) {
    _classCallCheck(this, Miniatura);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.imgRef = React.createRef();
    return _this;
  }

  Miniatura.prototype.render = function render() {
    var _props = this.props,
        vineta = _props.vineta,
        actual = _props.actual,
        onPulsar = _props.onPulsar,
        onReady = _props.onReady;
    var eventHandlers = {};

    if (onPulsar && !actual) {
      eventHandlers[NOMBRE_EVENTO_PULSAR] = function (e) {
        e.preventDefault();
        onPulsar(vineta);
      };
    }

    if (onReady) {
      eventHandlers['onLoad'] = onReady;
    }

    var clases = ['miniatura', actual ? 'activa' : ''].join(' ');
    return React.createElement('div', {
      className: clases
    }, React.createElement('img', _extends({
      className: 'imagenMiniatura',
      src: vineta.src
    }, eventHandlers, {
      alt: ''
    })), React.createElement('div', {
      className: 'textoMiniatura'
    }));
  };

  return Miniatura;
}(React.Component), _class.defaultProps = {
  actual: false
}, _temp);
Miniatura.propTypes = process.env.NODE_ENV !== "production" ? {
  vineta: t.shape({
    src: t.string.isRequired
  }).isRequired,
  actual: t.bool,
  onPulsar: t.func,
  onReady: t.func
} : {};
export default Miniatura;